import { render, staticRenderFns } from "./search-overlay.vue?vue&type=template&id=bd6c72d4&"
import script from "./search-overlay.vue?vue&type=script&lang=js&"
export * from "./search-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports